import React from 'react';
import { creditsData } from './creditsData';
import PageHeader from '../../components/global/PageHeader';
import classes from './Credits.module.css';

function Credits() {
  return (
    <div className={classes.creditsPage}>
      <PageHeader text="Cast" />
      {Object.keys(creditsData).map((section, i) => {
        const sectionElement = creditsData[section];
        return (
          <>
            <img src={sectionElement.img} className={classes.creditsImage} alt="credit-img" />
            <h3>{sectionElement.title}</h3>
            {sectionElement.rows.map((row) => (
              <div className={classes.creditsRowContainer}>
                <p>{row.characters}</p>
                <p className={classes.mobileText}>{row.actor}</p>
              </div>
            ))}
          </>
        );
      })}
    </div>
  );
}

export default Credits;



// WEBPACK FOOTER //
// ./src/containers/Credits/index.js